<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-label g-main-wrapper">
      <!-- filter -->
      <label-filter placeholder="请输入创意标签组名称或者ID" @on-set="openSet" @on-change="filterData" @on-search="searchFilterData" />
      <!-- table -->
      <div class="c-table-list">
        <label-table
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          @on-del="delLableGroups"
          @on-edit="openSet"
          @on-refresh="getData"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page"
          size="small"
        />
      </div>

      <!-- 弹出框 -->
      <label-set v-model="model" title="创意标签组" :info="info" :edit="edit" :loading="loading" @on-save="saveLableGroups" />
    </div>
  </Layout>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/labelgroups_column'
import { setLocal, getLocal } from '@/common/js/api'
import LabelFilter from './components/labelgroups-filter'
import LabelTable from './components/labelgroups-table'
import LabelSet from './components/labelgroups-set'
import { isArray, trim } from '@/common/js/utils'
import { listCreativeLable, getCreativeLableById, delCreativeLable, editCreativeLable, addCreativeLable } from '@/api/manage.model'
export default {
  name: 'labelgroups',
  mixins: [mixin],
  components: { LabelFilter, LabelTable, LabelSet },
  methods: {
    getData(filter) {
      let params = {
        pageId: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      listCreativeLable(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              return ret
            })
          } else this.$Message.error('数据返回格式错误！')
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('DOCUMENT_PAGESIZE', size)
    },
    delLableGroups(id) {
      delCreativeLable({ creativeLabelId: id })
        .then((data) => {
          if (data) {
            this.$Message.info('删除成功')
            this.getData()
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    openSet(edit) {
      this.edit = !!edit
      if (edit) {
        const { id } = edit
        this.loading = true
        getCreativeLableById({ creativeLabelId: id }).then((data) => {
          this.loading = false
          if (data) {
            const { id, title, labelDetailList } = data
            const labels = isArray(labelDetailList) ? labelDetailList : []
            this.info = { id, title, labels }
            this.model = true
          }
        })
      } else {
        this.info = { title: '', labels: [] }
        this.model = true
      }
    },
    saveLableGroups(params) {
      let { id, title, labels } = params
      title = trim(title)
      if (id) {
        this.loading = true
        const params = {
          creativeLabelId: id,
          creativeLabelTitle: title,
          creativeLabels: labels
        }
        editCreativeLable(params).then((data) => {
          this.loading = false
          if (data) {
            this.getData()
            this.model = false
          }
        })
      } else {
        this.loading = true
        const params = {
          creativeLabelId: id,
          creativeLabelTitle: title,
          creativeLabels: labels
        }
        addCreativeLable(params).then((data) => {
          this.loading = false
          if (data) {
            const { success, fail } = data
            if (typeof success === 'number' || typeof fail === 'number') {
              this.$Modal.info({
                title: '添加结果',
                content: `成功${data.success}条，失败${data.fail}条`,
                okText: '知道了'
              })
              this.getData()
              this.model = false
            } else this.$Message.error('添加创意标签组失败！')
          }
        })
      }
    }
  },
  data() {
    return {
      model: false, // 弹窗开关
      saving: false, // 设置状态
      edit: null,
      info: {
        title: '',
        label: []
      }
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('DOCUMENT_PAGESIZE')) || 20
    this.tableCol = columns
  }
}
</script>
<style lang="scss" scoped>
.c-label {
  width: 100%;
  height: 100%;
  padding-top: 10px;
}

.c-table-list {
  height: calc(100% - 48px);
}

.c-table-page {
  padding: 0 8px;
  margin-bottom: 0;
  text-align: right;
}
</style>
